import "./App.css";
import { Routes, Route } from "react-router-dom";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import BackToTop from "./components/BackToTop/BackToTop";

import Main from "./pages/Main/Main";

const colors = {
  primary: "#053C5E",
  secondary: "#BFDBF7",
  tertiary: "#A31621",
};

const styles = {
  global: {
    body: {
      bg: "primary",
    },
  },
};

const breakpoints = {
  sm: "30rem",
  md: "48rem",
  lg: "64rem",
  xl: "90rem",
  "2xl": "120rem",
};

const theme = extendTheme({ colors, styles, breakpoints });

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Routes>
        <Route path="/" element={<Main />} />
      </Routes>
      <BackToTop />
    </ChakraProvider>
  );
}

export default App;
